var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"95vh"}},[(_vm.dataUrl)?_c('iframe',{attrs:{"src":_vm.dataUrl,"height":"100%","width":"100%","name":_vm.value.name}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }